/** @file Zod schema of one [bone ref, weight] input pair of the weight commands. */
import { z } from 'zod';

/** [bone name or id, raw non-negative weight]; the commands merge, cap and normalize. */
export const influencePair = z.tuple([z.string().min(1), z.number().nonnegative()]);
